import React, { useState, useEffect } from 'react';
import { MdOutlineCancel } from 'react-icons/md';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import { useStateContext } from '../../contexts/ContextProvider';
import { FooterPages } from '..';
import DetailsIconButton from '../IconButtons/DetailsIconButton';
import DeleteIconButton from "../../components/IconButtons/DeleteIconButton";
import SeleccionaFecha from '../../components/DatePicker/SeleccionaFecha';
import ButtonBar from '../ButtonBar';
import ButtonToolBar from '../ButtonToolBar';
import { formatDate } from '../../formatters/date';
import { fetchUser } from '../../utils/fetchUser';
import SearchMaquinas from '../Search/SearchMaquinas';
import { getEquipos } from '../../services/Equipos';
import { getClientes } from '../../services/Clientes';
import { updateEstadoSolicitud, updateSelectedEquipo, updateFechaEnObra } from '../../services/Solicitudes';
import { updateAsignacion } from '../../services/Asignaciones';
import { crearMensaje, notificarUsuario } from '../../services/Util';
import { crearLog } from '../../services/AuditoriaLogs';
import { Toaster, toast } from 'react-hot-toast';
import DataTable from 'react-data-table-component';
import { uploadFile, downloadFile } from '../../services/filesTools';
import { eliminarEquipo as eliminarEquipoService } from '../../services/Carpetas';
import { set } from 'date-fns';

const initialState = {
  empresa: '',
  lin: 0,
  seleccionado: 'NO',
  idEquipo: '',
  codigoEquipo: '',
  nombreEquipo: '',
  marca: '',
  modelo: '',
  anno: '',
  serie: '',
  patente: '',
  origen: '',
  horometro: 0,
  kilometraje: 0,
  valorCotizacion: 0,
  horasminimas: "180",
  porcentaje: "",
  valorCotizacion2: 0,
  tarifaEstudio: 0,
  fechaEntrega: '',
  responsable: '',
  idUsuario: '',
  idProveedor: '',
  comentarios: '',
  idArchivo: null,
  aprobar: 0,
  nombreArchivo: '',
  idImplementa: null,
  linequipo: 0,
  idAutorizador: null,
  fechaAutorizacion: '',
  observacionAdm: '',
  estadoAutor: 'Pendiente',
};

const NuevaAsignacionTabs = ({ vecinoData, editableData, onChangeVecino }) => {
  const { isClicked, handleClick, setIsClicked } = useStateContext();
  const [formDataDisplay, setFormDataDisplay] = useState({});
  const [formData, setFormData] = useState(initialState);
  const [equipoData, setEquipoData] = useState([]);
  const [solicitudData, setSolicitudData] = useState([]);
  const [asignadosData, setAsignadosData] = useState([]);
  const [asignadosTabData, setAsignadosTabData] = useState([]);
  const [proveedoresData, setProveedoresData] = useState([]);
  const [selectedDateObra, setSelectedDateObra] = useState(getFirstDayOfMonth('Nada')); // Fecha inicial getFirstDayOfMonth('Fin')
  const [selectedRow, setSelectedRow] = useState(null);
  const [activeTab, setActiveTab] = useState(1);

  const [puedoAgregar, setPuedoAgregar] = useState(1);
  const [flagRed, setFlagRed] = useState(false);


  const [equipoDetalleEquipo, setEquipoDetalleEquipo] = useState('');
  const [tarifaEstudio, setTarifaEstudio] = useState(0);
  const [tarifaAllInclusive, setTarifaAllInclusive] = useState(0);
  const [fechaenObraDetalleEquipo, setFechaenObraDetalleEquipo] = useState('');

  const [cantidadDetalleEquipo, setCantidadDetalleEquipo] = useState(0);
  const [capacidadDetalleEquipo, setCapacidadDetalleEquipo] = useState('');

  const inputClass = "text-[11px] border border-gray-300 p-1.5 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-400";

  const [buttons, setButtons] = useState([
    { name: 'add', label: 'Agregar', disabled: false },
    { name: 'cancel', label: 'Limpiar', disabled: false },
  ]);

  //     { name: 'enviar', label: 'Enviar Aprobación', disabled: false },
  const [buttonsTool, setButtonsTool] = useState([
    { name: 'cancel', label: 'Cancelar', disabled: false },
    { name: 'save', label: 'Guardar', disabled: false },
  ]);

  const [buttonsToolAp, setButtonsToolAp] = useState([
    { name: 'rechazar', label: 'Rechazar', disabled: false },
    { name: 'aprobar', label: 'Aprobar', disabled: false },
  ]);

  const userInfo = fetchUser();
  const ROLES_LOGISTICA = ['Logística', 'SuperUsuario', 'Administrador'];
  const puedeGestionarEquipo = ROLES_LOGISTICA.includes(userInfo.rol);

  function getFirstDayOfMonth(Como) {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    if (Como === 'Inicio') return firstDay;
    if (Como === 'Fin') return today;
    if (Como === 'Nada') return null;
  };

  useEffect(() => {
    if (vecinoData) {
      // console.log("VECINO DATA " + JSON.stringify(vecinoData));
      setFormDataDisplay(vecinoData);
      setSolicitudData(vecinoData.detalleEquipos);
      setAsignadosData(vecinoData.detalleAsignados);
    }
  }, [vecinoData]);

  useEffect(() => {
    const fetchData = async () => {
      const misEquipos = await getEquipos();
      setEquipoData(misEquipos);
      const misProvee = await getClientes();
      setProveedoresData(misProvee);
      handleLimpiarMaquina();
    };
    fetchData();
  }, []);

  // RETORNO DEL VALOR SELECCIONADO DE LA BUSQUEDA
  const handleValorSeleccionadoChange = (equipoS) => {

    if (equipoS !== '') {
      let esPropio = equipoS.origen === "PROPIO" ? "SI" : "NO";
      setFormData({
        lin: formData.lin, seleccionado: esPropio, idEquipo: null,
        codigoEquipo: equipoS.codigo,
        nombreEquipo: equipoS.nombreEquipo,
        marca: equipoS.marca, modelo: equipoS.modelo,
        anno: equipoS.anno, serie: equipoS.serie, patente: equipoS.patente, origen: equipoS.origen,
        horometro: '', kilometraje: '',
        valorCotizacion: 0, horasminimas: '180', valorCotizacion2: 0, fechaEntrega: '', porcentaje: equipoS.origen === "PROPIO" ? "" : "2",
        responsable: userInfo.nombre, idUsuario: userInfo.usuario, idProveedor: '',
        idArchivo: null, aprobar: 0, nombreArchivo: '', idImplementa: null, linequipo: 0,
        idAutorizador: null, fechaAutorizacion: '', observacionAdm: '',
        estadoAutor: 'Pendiente'
      });
    }
  };

  const handleRowClick = (row) => {
    // LEER datos asignación asociados a la linea de la solicitud
    // Se limpia el formulario de equipo al cambiar de línea: evita que quede
    // "armado" en modo edición (formData.lin de una línea anterior) y que un
    // alta posterior termine reemplazando esa línea en vez de crear una nueva.
    handleLimpiarMaquina();
    setSelectedRow(row.lin);
    setPuedoAgregar(1);
    setEquipoDetalleEquipo(row.maquina);
    setTarifaEstudio(row.tarifaEstudio);
    setTarifaAllInclusive(row.tarifaAllInclusive);
    setCapacidadDetalleEquipo(row.capacidad);
    setCantidadDetalleEquipo(row.cantidad);
    setFechaenObraDetalleEquipo(row.fechaEnObra);
    const filtrados = asignadosData.filter(item => item.linequipo === row.lin);
    //const filtrados = asignadosData.filter(item => item.linequipo === row.lin).map(item => ({
    // ...item,
    // aprobar: row.selectedEquipo==1 ? 1 : 0,
    //}));

    // Actualizar asignadosTabData con los datos filtrados
    setAsignadosTabData(filtrados);
    setActiveTab(2);
  };

  const validateConditions = (row) => {
    // Aquí puedes poner tu lógica de validación
    // Por ejemplo, verificar si un campo específico no está vacío o si un valor es mayor que cero

    if (row.selectedEquipo === 1) {
      toast.error("El equipo ya fue enviado a Autorizar.");
      return false;
    }

    // Añade más validaciones según tus necesidades
    return true;
  };

  const handleToggleWithConfirmation = (dato) => {
    // 1. Validar las condiciones antes de proceder
    if (!validateConditions(dato)) {
      return; // Si la validación falla, se detiene la ejecución
    }

    // 2. Mostrar mensaje de confirmación
    toast.custom((t) => (
      <div className="bg-white p-6 rounded-lg shadow-lg w-96 max-w-full">
        <h3 className="text-lg font-semibold">
          ¿Está seguro de enviar a autorización estos equipos?
        </h3>
        <div className="flex justify-end gap-2 mt-4">
          <button
            type="button"
            className="px-4 py-2 bg-gray-400 text-white rounded"
            onClick={() => toast.dismiss(t.id)}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="px-4 py-2 bg-green-500 text-white rounded"
            onClick={() => {
              // 3. Si confirma, actualiza el estado
              toggleSelectedEquipo(dato);
              toast.dismiss(t.id);
            }}
          >
            Confirmar
          </button>
        </div>
      </div>
    ));
  };


  const toggleSelectedEquipo = (dato) => {
    setSolicitudData((prevData) =>
      prevData.map((row) =>
        row.lin === dato.lin
          ? { ...row, selectedEquipo: row.selectedEquipo === 1 ? 0 : 1 }
          : row
      )
    );

    const nuevoValor = dato.selectedEquipo === 1 ? 0 : 1;
    updateSelectedEquipoM(dato.lin, nuevoValor);
    toast.success(`Equipo ${nuevoValor === 1 ? "seleccionado" : "deseleccionado"}.`);
  };


  const handleChange = (e) => {
    const { name, value } = e.target;

    // Convertir valores a números si es necesario
    const updatedForm = {
      ...formData,
      [name]: value
    };

    // Parsear valores como números flotantes seguros

    const tarifaEstudioParsed =
      name === 'tarifaEstudio'
        ? (value === '' ? 0 : parseFloat(value))
        : parseFloat(tarifaEstudio) || 0;

    const valorCotizacion =
      name === 'valorCotizacion'
        ? (value === '' ? 0 : parseFloat(value))
        : parseFloat(updatedForm.valorCotizacion) || 0;

    if (name === 'tarifaEstudio') {
      setTarifaEstudio(value === '' ? '' : parseFloat(value));
    }

    setFlagRed(
      valorCotizacion > tarifaEstudioParsed &&
      valorCotizacion > 0 &&
      tarifaEstudioParsed > 0
    );

    const porcentaje = parseFloat(
      name === 'porcentaje' ? value : updatedForm.porcentaje
    ) || 0;

    const horasminimas = parseFloat(
      name === 'horasminimas' ? value : updatedForm.horasminimas
    ) || 0;

    // Calcular nuevo valorCotizacion2
    const valorCotizacion2 = (valorCotizacion * horasminimas) + ((valorCotizacion * horasminimas) * porcentaje / 100);

    // Calcular tarifaAllInclusive SOLO si el usuario NO está escribiendo en ese campo
    if (name === 'tarifaAllInclusive') {
      setTarifaAllInclusive(value);
    } else {
      if (name === 'horasminimas' || name === 'valorCotizacion') {
        setTarifaAllInclusive(valorCotizacion * horasminimas);
      }
    }

    // Actualizar estado incluyendo valorCotizacion2
    setFormData({
      ...updatedForm,
      valorCotizacion2: valorCotizacion2.toFixed(2), // o sin .toFixed si prefieres el número crudo
    });
  };


  const handleDateObraChange = (date) => {
    setSelectedDateObra(date);
  };

  const handleCompletaMaquina = async (row) => {

    setFormData({
      lin: row.lin, seleccionado: row.seleccionado, idEquipo: row.idEquipo,
      codigoEquipo: row.codigoEquipo,
      marca: row.marca, modelo: row.modelo, anno: row.anno,
      serie: row.serie, patente: row.patente, origen: row.origen,
      horometro: row.horometro, kilometraje: row.kilometraje,
      valorCotizacion: row.valorCotizacion, horasminimas: row.horasminimas,
      porcentaje: row.porcentaje,
      valorCotizacion2: row.valorCotizacion2, fechaEntrega: row.fechaEntrega,
      responsable: row.responsable, idUsuario: row.idUsuario, capacidad: row.capacidad,
      idProveedor: row.idProveedor,
      idArchivo: row.idArchivo, aprobar: row.aprobar, nombreArchivo: row.nombreArchivo,
      idImplementa: row.idImplementa, linequipo: row.linequipo, idAutorizador: row.idAutorizador,
      fechaAutorizacion: row.fechaAutorizacion, observacionAdm: row.observacionAdm, estadoAutor: row.estadoAutor
    });
  };

  const ejecutarEliminacionEquipo = async (row) => {
    try {
      const resultado = await eliminarEquipoService({
        idSolicitud: vecinoData.idSolicitud,
        idAsignacion: vecinoData._id,
        lineaAsig: row.lin,
      });

      const { lineaSolicitudEliminada, asignacionEliminada, solicitudEliminada } = resultado?.eliminados || {};
      let detalleLog = `Usuario eliminó el equipo ${row.codigoEquipo} del proceso (Carpeta, Implementa y Acreditación)`;
      if (solicitudEliminada) detalleLog += '. Al quedar sin equipos, también se eliminó la Solicitud y su Asignación';
      else if (asignacionEliminada) detalleLog += '. Al quedar sin equipos, también se eliminó la Asignación';

      await crearLog({
        opcion: 'Asignaciones',
        accion: 'Eliminar',
        idUsuario: userInfo.usuario,
        numeroSolicitud: vecinoData.numeroSolicitud,
        encabezado: `Solicitud N° ${vecinoData.numeroSolicitud} - Equipo ${row.codigoEquipo}`,
        detalle: detalleLog,
      });

      if (asignacionEliminada) {
        // No queda nada que mostrar en este modal: se cierra.
        toast.success('Equipo eliminado. La Asignación (y la Solicitud, si correspondía) se eliminó por quedar sin equipos.');
        onChangeVecino('REFRESH');
        setIsClicked(!isClicked.nuevaasignacion);
        return;
      }

      // Refresca el detalle abierto en el propio modal (vecinoData no se
      // vuelve a leer solo — el padre solo refresca la lista de fondo).
      setAsignadosData((prev) => prev.filter((item) => item.lin !== row.lin));
      setAsignadosTabData((prev) => prev.filter((item) => item.lin !== row.lin));

      if (lineaSolicitudEliminada) {
        setSolicitudData((prev) => prev.filter((item) => item.lin !== row.linequipo));
        setSelectedRow(null);
        setEquipoDetalleEquipo('');
        setFechaenObraDetalleEquipo('');
        setCapacidadDetalleEquipo('');
        setCantidadDetalleEquipo(0);
      }

      toast.success('Equipo eliminado correctamente.');
      onChangeVecino('REFRESH');
    } catch (error) {
      toast.error(error?.response?.data?.message || 'No se pudo eliminar el equipo.');
    }
  };

  const handleEliminar = (row) => {
    if (!row.idImplementa) {
      // Todavía no pasó por autorización (Carpeta/Implementa no existen):
      // solo se quita de la lista local, sin necesidad de persistir nada.
      setAsignadosData((prevData) => prevData.filter((item) => item.lin !== row.lin));
      setAsignadosTabData((prevData) => prevData.filter((item) => item.lin !== row.lin));
      return;
    }

    if (!puedeGestionarEquipo) {
      toast.error('No tiene permisos para eliminar este equipo.');
      return;
    }

    toast.custom((t) => (
      <div className="bg-white p-6 rounded-lg shadow-lg w-96 max-w-full">
        <h3 className="text-lg font-semibold">
          ¿Eliminar el equipo {row.codigoEquipo} del proceso?
        </h3>
        <p className="text-sm text-gray-600 mt-2">
          Se eliminará su Carpeta, Acreditación e Implementa (y los documentos que tenga cargados). Esta acción no se puede deshacer.
        </p>
        <div className="flex justify-end gap-2 mt-4">
          <button
            type="button"
            className="px-4 py-2 bg-gray-400 text-white rounded"
            onClick={() => toast.dismiss(t.id)}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="px-4 py-2 bg-red-600 text-white rounded"
            onClick={() => {
              toast.dismiss(t.id);
              ejecutarEliminacionEquipo(row);
            }}
          >
            Eliminar
          </button>
        </div>
      </div>
    ));
  };

  const handleLimpiarMaquina = async () => {
    setFormData({
      lin: 0,
      seleccionado: "NO",
      idEquipo: "",
      codigoEquipo: "",
      marca: "",
      modelo: "",
      anno: "",
      serie: "",
      patente: "",
      origen: "",
      horometro: "",
      kilometraje: "",
      valorCotizacion: 0,
      porcentaje: "2",
      valorCotizacion2: 0,
      tarifaEstudio: 0,
      horasminimas: "180",
      fechaEntrega: "",
      responsable: userInfo.nombre,
      idUsuario: userInfo.usuario,
      capacidad: "",
      idProveedor: "",
      idArchivo: null,
      aprobar: 0,
      nombreArchivo: '',
      idImplementa: null,
      linequipo: 0,
      idAutorizador: null,
      fechaAutorizacion: Date.now(),
      observacionAdm: "",
      estadoAutor: 'Pendiente',
    });
  };

  const handleAgregaMaquina = async () => {

    //    if (puedoAgregar === 0) {
    //      toast.error('No puede agregar más equipos, ya que la asignación está completa.');
    //      return;
    //    }

    if (!formData.marca || formData.marca === "") {
      toast.error('Debe Ingresar la marca.');
      return;
    };
    if (!formData.modelo || formData.modelo === "") {
      toast.error('Debe Ingresar el modelo.');
      return;
    };
    if (!formData.anno || formData.anno === "") {
      toast.error('Debe Ingresar el Año.');
      return;
    };
    /*  if (!formData.horometro || formData.horometro <= 0) {
        toast.error('Debe Ingresar el horometro.');
        return;
      };
      if (!formData.kilometraje || formData.kilometraje <= 0) {
        toast.error('Debe Ingresar el kilometraje.');
        return;
      };*/
    if (!formData.valorCotizacion || formData.valorCotizacion <= 0) {
      toast.error('Debe Ingresar el Valor UF por hora.');
      return;
    };
    if (!formData.valorCotizacion2 || formData.valorCotizacion2 <= 0) {
      toast.error('Debe Ingresar el Valor + 2%.');
      return;
    };
    if (!selectedDateObra || selectedDateObra === null) {
      toast.error('Debe Ingresar la Fecha de Obra.');
      return;
    };

    if (!formData.horasminimas || formData.horasminimas <= 0) {
      toast.error('Debe Ingresar las Horas Mínimas.');
      return;
    };

    if (formData.porcentaje < 0) {
      toast.error('Debe Ingresar el Porcentaje de incremento.');
      return;
    };

    if (!tarifaEstudio || tarifaEstudio <= 0) {
      toast.error('Debe Ingresar la Tarifa de Estudio.');
      return;
    };

    if (tarifaAllInclusive <= 0) {
      toast.error('Debe Ingresar la Tarifa All Inclusive.');
      return;
    };

    /*if (!formData.responsable || formData.responsable === "") {
      toast.error('Debe Ingresar el responsable');
      return;
    };*/

    // Si el origen es PROPIO, no se permite agregar más equipos
    // if (formData.origen === "PROPIO" && cantidadDetalleEquipo <= asignadosData.filter(item => item.linequipo === selectedRow).length + 1)
    // { 
    //   setPuedoAgregar(0);
    // }

    // Si formData.lin apunta a una línea que ya no pertenece a la máquina
    // seleccionada actualmente (quedó "armada" de una edición anterior sobre
    // otra línea), no se reemplaza esa línea — se agrega como una línea nueva,
    // para no pisar el equipo de otra máquina por error.
    const lineaAEditar = formData.lin !== 0
      ? asignadosData.find((item) => item.lin === formData.lin)
      : null;
    const esEdicionValida = Boolean(lineaAEditar && lineaAEditar.linequipo === selectedRow);

    const newData = {
      lin: esEdicionValida ? formData.lin : (asignadosData ? asignadosData.length + 1 : 1),
      seleccionado: formData.seleccionado,
      idEquipo: formData.idEquipo,
      codigoEquipo: formData.codigoEquipo || equipoDetalleEquipo,
      marca: formData.marca,
      modelo: formData.modelo,
      anno: formData.anno,
      serie: formData.serie,
      patente: formData.patente,
      origen: formData.origen,
      horometro: formData.horometro,
      kilometraje: formData.kilometraje,
      valorCotizacion: formData.valorCotizacion,
      horasminimas: formData.horasminimas,
      porcentaje: formData.porcentaje,
      tarifaEstudio: tarifaEstudio,
      valorCotizacion2: formData.valorCotizacion2,
      tarifaAllInclusive: tarifaAllInclusive,
      fechaEntrega: selectedDateObra.toISOString(),
      responsable: formData.responsable,
      idUsuario: formData.idUsuario,
      capacidad: formData.capacidad,
      idProveedor: formData.idProveedor,
      nombreProveedor: formData.idProveedor ? proveedoresData.find(p => p._id === formData.idProveedor)?.razonSocial : '',
      idArchivo: formData.idArchivo,
      aprobar: 0,
      nombreArchivo: formData.nombreArchivo,
      idImplementa: null,
      linequipo: selectedRow,
      idAutorizador: formData.idAutorizador,
      fechaAutorizacion: formData.fechaAutorizacion,
      observacionAdm: formData.observacionAdm,
      estadoAutor: 'Pendiente',
    };

    if (!esEdicionValida) {
      setAsignadosData((prevData) => [...prevData, newData]);
      setAsignadosTabData((prevData) => [...prevData, newData]);
    } else {
      setAsignadosData((prevData) =>
        prevData.map((item) => (item.lin === formData.lin ? newData : item))
      );
      setAsignadosTabData((prevData) =>
        prevData.map((item) => (item.lin === formData.lin ? newData : item))
      );
    }
    handleLimpiarMaquina();
  };

  const enviarAprobacion = async () => {

    if (formDataDisplay.estado === 'Aprobado') {
      toast.error('La Asignación se encuentra en un estado que no permite modificación');
      // console.log('La Asignación se encuentra en un estado que no permite modificación' + vecinoData.estado );
      return;
    }

    if (asignadosData.length === 0) {
      toast.error('Debe asignar al menos un Equipo.');
      // console.log('Debe asignar al menos un Equipo.');
      return;
    };

    // debe validar que si existen registros con proveedor al menos uno tenga 
    // seleccionado === SI
    try {
      // Debe verificar si grabo antes de enviar a aprobación
      // Si ya existe una asignación, actualiza los datos
      const upAsigna = {
        _id: vecinoData._id,
        detalleAsignados: asignadosData,
        estado: 'Asignado'
      };
      await updateAsignacion(upAsigna);

      onChangeVecino('REFRESH');
      setIsClicked(!isClicked.nuevaasignacion);
    } catch (error) {
      console.log(error);
      toast.error('Problemas al guardar asignación, contacte a Soporte.');
      return;
    }
  }

  const devolverAprobacion = async () => {
    const userInfo = fetchUser();

    if (formDataDisplay.estado !== 'Asignado') {
      toast.error('La Asignación se encuentra en un estado que no permite modificación');
      return;
    }

    if (asignadosData.length === 0) {
      toast.error('Debe asignar al menos un Equipo.');
      return;
    };

    try {
      const upAsigna = {
        _id: vecinoData._id,
        detalleAsignados: asignadosData,
        estado: 'Pendiente'
      };
      await updateAsignacion(upAsigna);

      onChangeVecino('REFRESH');
      setIsClicked(!isClicked.nuevaasignacion);
    } catch (error) {
      console.log(error);
      toast.error('Problemas al guardar asignación, contacte a Soporte.');
      return;
    }
  }

  const AprobarAsignacion = async () => {
    const userInfo = fetchUser();
    if (formDataDisplay.estado === 'Aprobado') {
      toast.error('La Asignación se encuentra en un estado que no permite modificación');
      return;
    };

    if (asignadosData.length === 0) {
      toast.error('Debe asignar al menos un Equipo.');
      return;
    };

    try {

      const subsetData = asignadosData.map((item) => ({
        lin: Number(item.lin),
        codigoEquipo: item.codigoEquipo,
        marca: item.marca,
        modelo: item.modelo,
        anno: Number(item.anno),
        serie: item.serie,
        patente: item.patente,
        origen: item.origen,
        horometro: Number(item.horometro),
        kilometraje: Number(item.kilometraje),
        capacidad: item.capacidad,
        tipo: item.tipo,
        idProveedor: item.idProveedor || null,
        idEquipo: item.idEquipo || null,
        fechaEntrega: item.fechaEntrega ? new Date(item.fechaEntrega) : null,
        valorCotizacion: Number(item.valorCotizacion),
        horasminimas: Number(item.horasminimas),
        porcentaje: Number(item.porcentaje),
        valorCotizacion2: Number(item.valorCotizacion2),
        idArchivo: item.idArchivo || null,
        nombreArchivo: item.nombreArchivo,
        responsable: item.responsable,
        seleccionado: item.seleccionado,
        aprobar: false,
        idImplementa: null,
        linequipo: Number(item.linequipo),
        idAutorizador: formData.idAutorizador || null,
        fechaAutorizacion: null,
        observacionAdm: formData.observacmionAd || "",
        estadoAutor: 'Pendiente'
      }));

      const upAsigna = {
        _id: vecinoData._id,
        detalleAsignados: subsetData,
        estado: 'Aprobado'
      };
      await updateAsignacion(upAsigna);

      setFormData(initialState);
      // onChangeVecino('REFRESH');
      // setIsClicked( !isClicked.nuevaasignacion );
    } catch (error) {
      console.log(error);
      toast.error('Problemas al guardar asignación, contacte a Soporte.');
      return;
    }
  }

  const handleSubmit = async () => {
    let elEquipoEs = '';

    //  console.log("ESTADO " + formDataDisplay.estado );
    if (formDataDisplay && formDataDisplay.estado !== 'Pendiente') {
      toast.error('La Asignación se encuentra en un estado que no permite modificación');
      return;
    }

    if (asignadosData.length === 0) {
      toast.error('Debe asignar al menos un Equipo.');
      return;
    };

    try {

      const subsetData = asignadosData.map((item) => ({
        lin: Number(item.lin),
        codigoEquipo: item.codigoEquipo,
        marca: item.marca,
        modelo: item.modelo,
        anno: Number(item.anno),
        serie: item.serie,
        patente: item.patente,
        origen: item.origen,
        horometro: Number(item.horometro),
        kilometraje: Number(item.kilometraje),
        capacidad: item.capacidad,
        tipo: item.tipo,
        idProveedor: item.idProveedor || null,
        idEquipo: item.idEquipo || null,
        fechaEntrega: item.fechaEntrega ? new Date(item.fechaEntrega) : null,
        valorCotizacion: Number(item.valorCotizacion),
        horasminimas: Number(item.horasminimas),
        porcentaje: Number(item.porcentaje),
        tarifaEstudio: Number(item.tarifaEstudio),
        valorCotizacion2: Number(item.valorCotizacion2),
        tarifaAllInclusive: Number(item.tarifaAllInclusive),
        idArchivo: item.idArchivo || null,
        nombreArchivo: item.nombreArchivo,
        responsable: item.responsable,
        seleccionado: item.seleccionado,
        aprobar: false,
        idImplementa: null,
        linequipo: Number(item.linequipo),
        idAutorizador: formData.idAutorizador || null,
        fechaAutorizacion: null,
        observacionAdm: formData.observacmionAd || "",
        estadoAutor: 'Pendiente'
      }));

      const upAsigna = {
        _id: formDataDisplay._id,
        detalleAsignados: subsetData,
        estado: 'Pendiente'
      };
      await updateAsignacion(upAsigna);

      // Graba estado Solicitud "En Proceso" solo si aún no fue aprobada
      if (formDataDisplay.estadoSolicitud !== 'Aprobada') {
        const upDatSol = {
          _id: formDataDisplay.idSolicitud,
          estado: 'En Proceso'
        };
        await updateEstadoSolicitud(upDatSol);
      }

      setFormData(initialState);
      toast.success('Asignación guardada correctamente.');
      // onChangeVecino('REFRESH');
      // setIsClicked( !isClicked.nuevaasignacion );

    } catch (error) {
      console.log(error);
      toast.error('Problemas al guardar asignación, contacte a Soporte.');
      return;
    }
  };


  const updateSelectedEquipoM = async (lin, valor) => {
    const upData = async () => {
      await updateSelectedEquipo({ _id: vecinoData.idSolicitud, lin: lin, selectedEquipo: valor });

      const dataMensaje = {
        numeroSolicitud: vecinoData.numeroSolicitud
      };
      const mensaje = crearMensaje(vecinoData.idAdministrador, 'autorizarAsignacion', dataMensaje);
      await notificarUsuario(JSON.stringify(mensaje));

      if (vecinoData.idJefeTecnico !== '') {
        const mensajeTec = crearMensaje(vecinoData.idJefeTecnico, 'autorizarAsignacion', dataMensaje);
        await notificarUsuario(JSON.stringify(mensajeTec));
      }

    };
    upData();
  };

  const handleFechaEnObraDetalleChange = (date) => {
    if (!date || selectedRow === null || selectedRow === undefined) return;
    if (!puedeGestionarEquipo) {
      toast.error('No tiene permisos para modificar la Fecha en Obra.');
      return;
    }

    const fechaAnterior = fechaenObraDetalleEquipo;
    setFechaenObraDetalleEquipo(date);
    setSolicitudData((prevData) =>
      prevData.map((row) =>
        row.lin === selectedRow ? { ...row, fechaEnObra: date } : row
      )
    );

    const actualizar = async () => {
      try {
        await updateFechaEnObra({ _id: vecinoData.idSolicitud, lin: selectedRow, fechaEnObra: date });

        await crearLog({
          opcion: 'Asignaciones',
          accion: 'Editar',
          idUsuario: userInfo.usuario,
          numeroSolicitud: vecinoData.numeroSolicitud,
          encabezado: `Solicitud N° ${vecinoData.numeroSolicitud} - Equipo ${equipoDetalleEquipo}`,
          detalle: `Usuario modificó Fecha en Obra de ${fechaAnterior ? formatDate(fechaAnterior) : 'sin fecha'} a ${formatDate(date)}`,
        });

        toast.success('Fecha en Obra actualizada.');
      } catch (error) {
        toast.error('No se pudo actualizar la Fecha en Obra.');
      }
    };
    actualizar();
  };

  const handleButtonClick = (buttonName) => {
    // console.log(`Button clicked: ${buttonName}`);
    // Realiza acciones basadas en el botón presionado
    if (buttonName === 'add') {
      handleAgregaMaquina();
    } else if (buttonName === 'cancel') {
      handleLimpiarMaquina();
    }
  };

  const handleButtonToolBarClick = (buttonName) => {
    if (buttonName === 'save') {
      handleSubmit();
    } else if (buttonName === 'enviar') {
      enviarAprobacion();
    } else if (buttonName === 'cancel') {
      handleCancelar();
    } else if (buttonName === 'aprobar') {
      AprobarAsignacion();
    } else if (buttonName === 'rechazar') {
      devolverAprobacion();
    }
  };

  const handleCancelar = () => {

    onChangeVecino('REFRESH');
    setIsClicked(!isClicked.nuevaasignacion);
  };

  const handleFileChange = async (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    const response = await uploadFile(selectedFile);
    if (response && response.fileId) {

      setFormData({ ...formData, nombreArchivo: selectedFile.name, idArchivo: response.fileId });

    } else {
      toast.error('Error al subir el archivo.');
      console.error('Error de carga:');
    }
  };

  const descargarDocumento = async () => {
    if (formData.idArchivo) {
      await downloadFile(formData.idArchivo, formData.nombreArchivo || "documento.pdf");
    }
  };

  const customStyles = {
    table: {
      style: {
        backgroundColor: 'white',
        borderRadius: '8px',
      },
    },
    head: {
      style: {
        fontSize: '14px',
        fontWeight: 'bold',
        color: '#2F336A',
        backgroundColor: '#F2F5FE',
        borderBottom: '1px solid #D9E1F2',
      },
    },
    headRow: {
      style: {
        minHeight: '48px',
        borderBottomWidth: '1px',
      },
    },
    headCells: {
      style: {
        paddingLeft: '12px',
        paddingRight: '12px',
        whiteSpace: 'nowrap',
      },
    },
    rows: {
      style: {
        fontSize: '13px',
        backgroundColor: 'white',
        minHeight: '52px',
        borderBottom: '1px solid #F3F4F6',
        transition: 'background-color 0.2s ease-in-out',
      },
      highlightOnHoverStyle: {
        backgroundColor: '#F9FAFB',
        borderBottomColor: '#E5E7EB',
        outline: 'none',
      },
    },
    cells: {
      style: {
        paddingLeft: '12px',
        paddingRight: '12px',
      },
    },
  };

  const columnsEq = [
    {
      name: "",
      width: "50px",
      cell: (row) => (
        <div
          onClick={(e) => {
            e.stopPropagation(); // Evita que el clic afecte la selección completa de la fila
            handleToggleWithConfirmation(row);
          }}
          className="cursor-pointer"
        >
          {row.selectedEquipo === 1 ? (
            <FaCheckCircle color="green" size={24} />
          ) : (
            <FaCheckCircle color="gray" size={24} />
          )}
        </div>
      ),
    },
    {
      name: '',
      width: '40px',
      cell: (row) => (<DetailsIconButton onClick={() => handleRowClick(row)} />)
    },
    {
      name: "Lin",
      width: "40px",
      selector: (row) => row.lin,
      sortable: true,
    },
    {
      name: "Enviado",
      width: "100px",
      selector: row => row.selectedEquipo,
      sortable: true,
      cell: (row) => {
        let bgColor = '';
        switch (row.selectedEquipo) {
          case 1:
            bgColor = 'bg-green-100 text-green-700';
            break;
          case 0:
            bgColor = 'bg-yellow-100 text-yellow-700';
            break;
          default:
            bgColor = 'bg-gray-100 text-gray-700';
        }
        return (
          <div className={`text-xs px-2 py-1 rounded-full text-center ${bgColor}`}>
            {row.selectedEquipo === 1 ? 'SI' : 'NO'}
          </div>
        );
      }
    },
    {
      name: 'Estado Asignación',
      width: '200px',
      selector: row => row.estadoEquipo,
      sortable: true,
      cell: (row) => {
        let bgColor = '';
        switch (row.estadoEquipo) {
          case 'Aprobado':
            bgColor = 'bg-green-100 text-green-700';
            break;
          case 'Pendiente':
            bgColor = 'bg-gray-100 text-gray-700';
            break;
          default:
            bgColor = 'bg-gray-100 text-gray-700';
        }
        return (
          <div className={`text-xs px-2 py-1 rounded-full text-center ${bgColor}`}>
            {row.estadoEquipo}
          </div>
        );
      }
    },
    {
      name: 'Fecha en Obra',
      width: '150px',
      selector: row => formatDate(row.fechaEnObra),
      sortable: true
    },
    {
      name: 'Equipo',
      width: '250px',
      selector: row => row.maquina,
      sortable: true
    },
    {
      name: 'Cantidad',
      width: '120px',
      selector: row => row.cantidad,
      sortable: true
    },
    {
      name: 'Capacidad',
      width: '120px',
      selector: row => row.capacidad,
      sortable: true
    },
    {
      name: 'Permanencia',
      width: '120px',
      selector: row => row.permanencia,
      sortable: true
    },
    {
      name: 'Comentario',
      width: '300px',
      selector: row => row.comentario,
      sortable: true
    },
  ];

  /*
      {
        name: '',
        width: '40px',
        cell: (row) => ( <UploadIconButton onClick={() => handleGetDocu(row)} /> )
      },
  
  */

  const columnsMaq = [
    {
      name: '',
      width: '40px',
      cell: (row) => (<DeleteIconButton onClick={() => handleEliminar(row)} />)
    },
    {
      name: 'Lin',
      width: '40px',
      selector: row => row.lin,
      sortable: true
    },
    {
      name: 'Equipo',
      width: '100px',
      selector: row => row.codigoEquipo,
      sortable: true
    },
    {
      name: 'Capacidad',
      width: '150px',
      selector: row => row.capacidad,
      sortable: true
    },
    {
      name: 'Marca',
      width: '150px',
      selector: row => row.marca,
      sortable: true
    },
    {
      name: 'Modelo',
      width: '100px',
      selector: row => row.modelo,
      sortable: true
    },
    {
      name: 'Año',
      width: '100px',
      selector: row => row.anno,
      sortable: true
    },
    {
      name: 'Horometro',
      width: '150px',
      selector: row => row.horometro,
      sortable: true
    },
    {
      name: 'Kilometraje',
      width: '150px',
      selector: row => row.kilometraje,
      sortable: true
    },
    {
      name: 'Valorización',
      width: '150px',
      selector: row => row.valorCotizacion,
      sortable: true
    },
    {
      name: 'Horas mínimas',
      width: '120px',
      selector: row => row.horasminimas,
      sortable: true
    },
    {
      name: 'Porcentaje',
      width: '120px',
      selector: row => row.porcentaje,
      sortable: true
    },
    {
      name: 'Tarifa Estudio',
      width: '150px',
      selector: row => row.tarifaEstudio,
      sortable: true
    },
    {
      name: 'Tarifa All Inclusive',
      width: '150px',
      selector: row => row.tarifaAllInclusive,
      sortable: true
    },
    {
      name: 'Fecha Entrega',
      width: '150px',
      selector: row => formatDate(row.fechaEntrega),
      sortable: true
    },
    {
      name: 'Proveedor',
      width: '150px',
      selector: row => row.nombreProveedor,
      sortable: true
    },
    {
      name: 'Archivo',
      width: '150px',
      selector: row => row.nombreArchivo,
      sortable: true
    }
  ];

  return (
    <form onSubmit={handleSubmit} >
      <div className="bg-half-transparent w-full fixed nav-item top-0 right-0">
        <div className="overflow-y-scroll float-right h-screen duration-1000 ease-in-out dark:text-gray-200 transition-all dark:bg-[#484B52] bg-gray-100  w-full md:w-full p-8">

          <div className="flex justify-between items-center px-4 py-2 border-b border-gray-200 bg-white rounded-t-md shadow-sm">
            <div className="flex items-center gap-2">
              <div className="w-2.5 h-2.5 rounded-full bg-blue-500 animate-pulse" />
              <p className="text-gray-800 font-semibold text-base md:text-lg">
                Asignar Equipos
              </p>
            </div>

            <button
              type="button"
              onClick={() => handleCancelar()}
              className="text-gray-400 hover:text-red-500 transition-colors duration-150 p-2 rounded-full hover:bg-gray-100"
              aria-label="Cerrar"
            >
              <MdOutlineCancel className="text-xl md:text-2xl" />
            </button>
          </div>

          <div className="bg-gray-200 p-6 rounded-lg shadow-lg">
            <div className="grid grid-cols-2 md:grid-cols-10 gap-4" >
              <div className="flex flex-col items-start">
                <label className="text-xs font-semibold mb-1">Fecha</label>
                <input
                  className={inputClass}
                  type="text"
                  placeholder=""
                  name="fechaCreacion"
                  value={formatDate(vecinoData.fechaCreacion)}
                  disabled
                />
              </div>
              <div className="flex flex-col">
                <label className="text-xs font-semibold mb-1">Tipo Solicitud</label>
                <input
                  className={inputClass}
                  type="text"
                  placeholder=""
                  name="tipoSolicitud"
                  value={formDataDisplay.tipoSolicitud}
                  disabled
                />
              </div>
              <div className="flex flex-col">
                <label className="text-xs font-semibold mb-1">N° Solicitud</label>
                <input
                  className={inputClass}
                  type="text"
                  placeholder=""
                  name="numeroSolicitud"
                  value={vecinoData.numeroSolicitud}
                  disabled
                />
              </div>
              <div className="col-span-2">
                <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Solicitante</label>
                  <input
                    className={inputClass}
                    type="text"
                    placeholder=""
                    name="solicitante"
                    value={formDataDisplay.solicitante}
                    disabled
                  />
                </div>
              </div>

              <div className="col-span-2">
                <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Jefe Of. Técnica</label>
                  <input
                    className={inputClass}
                    type="text"
                    placeholder=""
                    name="nombreAprobador"
                    value={formDataDisplay.nombreAprobador}
                    disabled
                  />
                </div>
              </div>

              <div className="col-span-2">
                <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Administrador</label>
                  <input
                    className={inputClass}
                    type="text"
                    placeholder=""
                    name="nombreAdministrador"
                    value={formDataDisplay.nombreAdministrador}
                    disabled
                  />
                </div>
              </div>
              <div className="flex flex-col ">
                <label className="text-xs font-semibold mb-1">Estado Solicitud</label>
                <input
                  className={inputClass}
                  type="text"
                  placeholder=""
                  name="estadoSolicitud"
                  value={formDataDisplay.estadoSolicitud}
                  disabled
                />
              </div>
            </div>

            <div className="grid grid-cols-3 md:grid-cols-9 gap-4 mt-2" >
              <div className="flex flex-col">
                <label className="text-xs font-semibold mb-1">Centro Costo</label>
                <input
                  className={inputClass}
                  type="text"
                  placeholder=""
                  name="codigoCentro"
                  value={formDataDisplay.codigoCentro}
                  disabled
                />
              </div>
              <div className="col-span-2">
                <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Proyecto</label>
                  <input
                    className={inputClass}
                    type="text"
                    placeholder=""
                    name="nombreProyecto"
                    value={formDataDisplay.nombreProyecto}
                    disabled
                  />
                </div>
              </div>
              <div className="col-span-2">
                <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Ubicación</label>
                  <input
                    className={inputClass}
                    type="text"
                    placeholder=""
                    name="ubicacion"
                    value={formDataDisplay.ubicacion}
                    disabled
                  />
                </div>
              </div>
              <div className="col-span-3">
                <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Observación</label>
                  <input
                    className={inputClass}
                    type="text"
                    placeholder=""
                    name="observacionAdm"
                    value={formDataDisplay.observacionAdm}
                    disabled
                  />
                </div>
              </div>
            </div>


            <div className="grid grid-cols-1 md:grid-cols-1 gap-8 mt-2">
              <div className="bg-white p-6 rounded-lg shadow-lg">
                <div className="grid grid-cols-4 md:grid-cols-12 gap-4" >
                  <div className="flex space-x-2 mb-4">
                    {['Solicitud', 'Asignación'].map((tab, index) => (
                      index === 0 &&
                      <button
                        key={index}
                        onClick={(e) => {
                          e.preventDefault(); // Evitar comportamiento de envío
                          setActiveTab(index + 1);
                        }}
                        className={`px-4 py-2 rounded-t ${activeTab === index + 1
                          ? 'bg-blue-500 text-white'
                          : 'bg-gray-200 text-gray-700'
                          }`}
                      >
                        {tab}
                      </button>
                    ))}
                  </div>
                </div>


                {activeTab === 1 && (
                  <div className="grid grid-cols-1 md:grid-cols-1 gap-4" >
                    <div className="flex flex-col">
                      <DataTable
                        columns={columnsEq}
                        data={solicitudData}
                        highlightOnHover
                        pagination={true}
                        striped
                        className="border border-gray-300 rounded-lg shadow-sm"
                        noHeader={true}
                        selectableRowsHighlight
                        customStyles={customStyles}
                        onRowClicked={handleRowClick}
                      />
                    </div>
                  </div>
                )}
                {activeTab === 2 && (
                  <>
                    <div className=" dark:text-gray-200 transition-all dark:bg-[#484B52] bg-gray-100 p-8">
                      <div className="grid grid-cols-12 md:grid-cols-12 gap-4" >
                        <div className="col-span-11">



                          <div className="grid grid-cols-4 md:grid-cols-10 gap-4" >
                            {editableData === "ON" &&
                              <div className="flex flex-col mt-5">
                                <SearchMaquinas dataI={equipoData} onValorSeleccionadoChange={handleValorSeleccionadoChange} />
                              </div>
                            }
                            <div className="flex flex-col">
                              <label className="text-xs font-semibold mb-1">N° Interno</label>
                              <input
                                className={inputClass}
                                type="text"
                                placeholder=""
                                name="codigoEquipo"
                                value={formData.codigoEquipo}
                                disabled
                                onChange={handleChange}
                              />
                            </div>
                            {/*  <div className="flex flex-col">
                      <label className="text-xs font-semibold mb-1">Linea</label>
                        <input
                            className={inputClass}
                            type="text"
                            placeholder=""
                            name="lin"
                            value= {formData.lin}
                            disabled 
                            onChange={handleChange}
                          />
                    </div>
                    */}
                            <div className="col-span-2">
                              <div className="flex flex-col">
                                <label className="text-xs font-semibold mb-1">Marca*</label>
                                <input
                                  className={inputClass}
                                  type="text"
                                  placeholder=""
                                  name="marca"
                                  value={formData.marca}
                                  disabled={editableData === "ON" ? false : true}
                                  required
                                  onChange={handleChange}
                                />
                              </div>
                            </div>
                            <div className="flex flex-col">
                              <label className="text-xs font-semibold mb-1">Modelo</label>
                              <input
                                className={inputClass}
                                type="text"
                                placeholder=""
                                name="modelo"
                                value={formData.modelo}
                                disabled={editableData === "ON" ? false : true}
                                required
                                onChange={handleChange}
                              />
                            </div>

                            <div className="flex flex-col">
                              <label className="text-xs font-semibold mb-1">Capacidad</label>
                              <input
                                className={inputClass}
                                type="text"
                                placeholder=""
                                name="capacidad"
                                value={formData.capacidad}
                                disabled={editableData === "ON" ? false : true}
                                required
                                onChange={handleChange}
                              />
                            </div>

                            <div className="flex flex-col">
                              <label className="text-xs font-semibold mb-1">Año*</label>
                              <input
                                className={inputClass}
                                type="number"
                                placeholder=""
                                name="anno"
                                value={formData.anno}
                                disabled={editableData === "ON" ? false : true}
                                required
                                onChange={handleChange}
                              />
                            </div>
                            <div className="flex flex-col">
                              <label className="text-xs font-semibold mb-1">Horometro</label>
                              <input
                                className={inputClass}
                                type="number"
                                placeholder=""
                                name="horometro"
                                value={formData.horometro}
                                disabled={editableData === "ON" ? false : true}
                                required
                                onChange={handleChange}
                              />
                            </div>
                            <div className="flex flex-col">
                              <label className="text-xs font-semibold mb-1">Kilometraje</label>
                              <input
                                className={inputClass}
                                type="number"
                                placeholder=""
                                name="kilometraje"
                                value={formData.kilometraje}
                                disabled={editableData === "ON" ? false : true}
                                required
                                onChange={handleChange}
                              />
                            </div>
                            <div className="flex flex-col">
                              <label className="text-xs font-semibold mb-1">UF por hora*</label>
                              <input
                                className={inputClass}
                                type="number"
                                placeholder=""
                                name="valorCotizacion"
                                value={formData.valorCotizacion}
                                disabled={editableData === "ON" ? false : true}
                                required
                                onChange={handleChange}
                              />
                            </div>
                          </div>
                          <div className="grid grid-cols-4 md:grid-cols-10 gap-4 mt-2" >
                            <div className="flex flex-col">
                              <label className="text-xs font-semibold mb-1">Horas mínimas*</label>
                              <select className={inputClass} name="horasminimas" value={formData.horasminimas} onChange={handleChange}>
                                <option value="180">180</option>
                                <option value="200">200</option>
                                <option value="360">360</option>
                              </select>
                            </div>
                            <div className="flex flex-col">
                              <label className="text-xs font-semibold mb-1">Porcentaje</label>
                              <select className={inputClass} name="porcentaje" value={formData.porcentaje} onChange={handleChange}>
                                <option value=""></option>
                                <option value="2">2%</option>
                                <option value="3">3%</option>
                              </select>
                            </div>
                            <div className="flex flex-col">
                              <label className="text-xs font-semibold mb-1">Tarifa Estudio*</label>
                              <input
                                className={inputClass}
                                type="number"
                                placeholder=""
                                name="tarifaEstudio"
                                value={tarifaEstudio}
                                disabled={editableData === "ON" ? false : true}
                                required
                                onChange={handleChange}
                              />
                            </div>
                            {flagRed && (
                              <div className="flex flex-col">
                                <label className="text-xs font-semibold mb-1">
                                  Diferencia Tarifa
                                </label>

                                <input
                                  className={`${inputClass} bg-red-200 text-red-700 font-bold`}
                                  type="number"
                                  name="diferenciaTarifa"
                                  value={formData.valorCotizacion - tarifaEstudio}
                                  disabled
                                />
                              </div>
                            )}
                            <div className="flex flex-col">
                              <label className="text-xs font-semibold mb-1">Tarifa All Inclusive</label>
                              <input
                                className={inputClass}
                                type="number"
                                placeholder=""
                                name="tarifaAllInclusive"
                                value={tarifaAllInclusive}
                                disabled={editableData === "ON" ? false : true}
                                onChange={handleChange}
                              />
                            </div>
                            <div className="col-span-2">
                              <div className="flex flex-col">
                                <label className="text-xs font-semibold mb-1">Proveedor</label>
                                <select className={inputClass} name="idProveedor" value={formData.idProveedor} onChange={handleChange}>
                                  <option value=""></option>
                                  {proveedoresData?.map((item, index) => (
                                    <option value={item._id}>{item.razonSocial}</option>
                                  ))}
                                </select>
                              </div>
                            </div>

                            <div className="col-span-2">
                              <div className="flex flex-col">
                                <label className="text-xs font-semibold mb-1">Fecha Entrega*</label>
                                <SeleccionaFecha
                                  selectedDate={selectedDateObra}
                                  handleDateChange={handleDateObraChange}
                                />
                              </div>
                            </div>
                            <div className="col-span-2">
                              <div className="flex flex-col">
                                <label className="text-xs font-semibold mb-2 text-gray-700">Cotización (PDF)</label>

                                <input
                                  type="file"
                                  accept=".pdf,.xlsx,.xls,.zip,.rar,.docx,.doc,.png,.jpg,.jpeg"
                                  onChange={(e) => handleFileChange(e)}
                                  className="block w-full text-xs text-gray-700 file:mr-4 file:py-1 file:px-2 file:rounded file:border-0 file:text-xs file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100 transition"
                                />

                                {formData.idArchivo && (
                                  <div className="mt-3 flex flex-col sm:flex-row sm:items-center sm:justify-between bg-gray-100 p-3 rounded shadow-sm border border-gray-200">
                                    <p className="text-xs text-gray-700 truncate mb-2 sm:mb-0">
                                      <span className="font-medium">Archivo:</span> {formData.nombreArchivo}
                                    </p>
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="flex flex-col mt-5">
                              <button
                                type="button"
                                className="bg-green-500 hover:bg-green-600 text-white text-xs px-3 py-1 rounded shadow transition"
                                onClick={() => descargarDocumento()}
                                disabled={!formData.idArchivo}
                              >
                                Descargar
                              </button>
                            </div>


                          </div>

                        </div>

                        <div className="flex flex-col mt-4">
                          <ButtonBar buttons={buttons} onButtonClick={handleButtonClick} />
                        </div>
                      </div>

                    </div>
                    <div className=" dark:text-gray-200 transition-all dark:bg-[#484B52] bg-gray-100 p-8 mt-2">
                      <div className="grid grid-cols-1 md:grid-cols-1 gap-4" >
                        <div className="flex flex-col">
                          <DataTable
                            columns={columnsMaq}
                            data={asignadosTabData}
                            highlightOnHover
                            pagination={true}
                            striped
                            className="border border-gray-300 rounded-lg shadow-sm"
                            noHeader={true}
                            selectableRowsHighlight
                            customStyles={customStyles}
                            onRowClicked={(row) => handleCompletaMaquina(row)}
                            noDataComponent={'No hay Maquinas Asignadas'}
                          />
                        </div>
                      </div>
                    </div>
                    <div className=" dark:text-gray-200 transition-all dark:bg-[#484B52] bg-gray-100 p-8 mt-2">
                      <div className="grid grid-cols-3 md:grid-cols-6 gap-4" >
                        <div className="flex flex-col">
                          <label className="text-xs font-semibold mb-1">Equipo Solicitado</label>
                          <input
                            className={inputClass}
                            type="text"
                            placeholder=""
                            name="equipoSolicitud"
                            value={equipoDetalleEquipo}
                            disabled
                          />
                        </div>
                        <div className="flex flex-col">
                          <label className="text-xs font-semibold mb-1">Fecha en Obra</label>
                          <SeleccionaFecha
                            selectedDate={fechaenObraDetalleEquipo ? new Date(fechaenObraDetalleEquipo) : null}
                            handleDateChange={handleFechaEnObraDetalleChange}
                            disabled={selectedRow === null || selectedRow === undefined || !puedeGestionarEquipo}
                          />
                        </div>
                        <div className="flex flex-col">
                          <label className="text-xs font-semibold mb-1">Días en Obra</label>
                          <input
                            className={inputClass}
                            type="text"
                            placeholder=""
                            name="diasEnObra"
                            value={
                              fechaenObraDetalleEquipo
                                ? (() => {
                                  const hoy = new Date();
                                  const fechaObra = new Date(fechaenObraDetalleEquipo);
                                  const diffDias = Math.floor(
                                    Math.abs(hoy - fechaObra) / (1000 * 60 * 60 * 24)
                                  );
                                  return hoy > fechaObra ? -diffDias : diffDias;
                                })()
                                : ""
                            }
                            disabled
                          />
                        </div>
                        <div className="flex flex-col">
                          <label className="text-xs font-semibold mb-1">Capacidad</label>
                          <input
                            className={inputClass}
                            type="text"
                            placeholder=""
                            name="id"
                            value={capacidadDetalleEquipo}
                            disabled
                          />
                        </div>
                        <div className="flex flex-col">
                          <label className="text-xs font-semibold mb-1">Cantidad</label>
                          <input
                            className={inputClass}
                            type="text"
                            placeholder=""
                            name="cantidadDetalleEquipo"
                            value={cantidadDetalleEquipo}
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>



            <div className="bg-white p-6 rounded-lg shadow-lg items-end mt-4">
              {editableData === "ON" &&
                <div className="flex flex-col mt-4">
                  <ButtonToolBar buttons={buttonsTool} onButtonClick={handleButtonToolBarClick} />
                </div>
              }
              {editableData === "OFF" &&
                <div className="flex flex-col mt-4">
                  <ButtonToolBar buttons={buttonsToolAp} onButtonClick={handleButtonToolBarClick} />
                </div>
              }

            </div>
            <Toaster
              position="top-right"
              toastOptions={{
                style: {
                  zIndex: 9999,
                },
              }}
            />
            <FooterPages />
          </div>

        </div>
      </div>

    </form>

  );
};

export default NuevaAsignacionTabs;